export const copy = {
  en: {
    meta: "Ali Idrees, software engineer at Brainchimps. M.Sc. AI Engineering at Universität Passau.",
    nav: {
      label: "Page",
      about: "about",
      experience: "experience",
      projects: "projects",
      skills: "skills",
      contact: "contact",
    },
    theme: { toLight: "Switch to light mode", toDark: "Switch to dark mode" },
    lang: { switch: "Switch to German" },
    hero: {
      role: "computer scientist {software engineer} - human",
      bio: "Full-stack engineer at Brainchimps, focused on backend systems and AI. M.Sc. AI Engineering at Universität Passau, after a BS Computer Science at FAST-NUCES.",
      projects: "view projects",
      email: "email me",
      cv: "download cv",
      comment: "// what I work on",
      roleValue: "Software Engineer",
      study: "M.Sc. AI Engineering, Passau",
      focus: ["backend", "APIs", "AI"],
    },
    work: {
      heading: "experience",
      explore: "explore ↗",
      items: [
        { title: "Software Engineer", org: "Brainchimps", when: "Sept 2025 – Current", place: "Germany" },
        { title: "Software Engineer", org: "CodingCops", when: "April 2024 – April 2025", place: "USA (Remote)" },
        { title: "Associate Software Engineer", org: "Kiwi Creations", when: "March 2023 – September 2023", place: "Lahore, Pakistan" },
        { title: "Teaching Assistant", org: "FAST-NUCES", when: "Aug 2022 – Jan 2023", place: "Lahore, Pakistan" },
      ],
    },
    study: {
      heading: "study",
      items: [
        { degree: "M.Sc. AI Engineering", org: "Universität Passau", place: "Passau, Germany" },
        { degree: "BS Computer Science", org: "FAST-NUCES", place: "Lahore, Pakistan" },
      ],
    },
    projects: {
      heading: "projects",
      open: "open ↗",
      all: "all",
      empty: "Nothing under this tag.",
      filter: "Filter projects",
      items: [
        {
          desc: "A multi-role web platform connecting brands, influencers, and customers, with Amazon affiliate integrations. Campaign and document management, Mailgun email, and secure AWS S3 uploads. React on the front, NestJS (Clean Architecture) and PostgreSQL on the back.",
          alt: "UBU Platform product preview",
        },
        {
          desc: "A full-stack AI platform on the MERN stack, integrated with OpenAI. Structured prompts create documents, PDFKit generates the PDFs, and OpenAI synthesizes the content.",
          alt: "Mind Miner product preview",
        },
        {
          desc: "An AI chatbot built on OpenAI's GPT model. Embeddings and cosine similarity keep replies tied to the right context.",
          alt: "People collaborating around laptops",
        },
      ],
    },
    skills: {
      heading: "skills",
      groups: [
        { name: "frontend", items: ["React", "TypeScript", "Tailwind"] },
        { name: "backend", items: ["NestJS", "Node.js", ".NET", "Python"] },
        { name: "data", items: ["PostgreSQL", "MongoDB"] },
        { name: "cloud", items: ["AWS", "Docker"] },
        { name: "practice", items: ["REST APIs", "Clean Architecture", "Unit testing"] },
      ],
    },
    contact: {
      heading: "contact",
      intro: "Send a note, or book half an hour.",
      book: "book 30 minutes",
      name: "name",
      email: "email",
      message: "message",
      send: "send",
      sending: "sending",
      sent: "Sent. I’ll reply by email.",
      error: "That didn’t send. Use the email below.",
    },
    activity: {
      heading: "activity",
      unit: "contribution",
      unitPlural: "contributions",
      unavailable: "GitHub activity is unavailable right now.",
    },
    footer: "ali idrees · germany",
    experience: {
      label: "Experience chapters",
      next: "next",
      home: "back home",
      at: "at",
      chapters: [
        {
          when: "Sept 2025 – Current",
          title: "Software Engineer",
          body: "Full-stack engineer on industrial projects, focused on backend systems.",
          tags: ["Backend", "AI", "MCP"],
          place: "Germany",
        },
        {
          title: "Software Engineer",
          when: "April 2024 – April 2025",
          body: "Service work for international clients. NestJS backends with Clean Architecture, REST APIs, AWS S3, and React dashboards.",
          tags: ["NestJS", "React", "AWS S3", "REST"],
          place: "USA (Remote)",
        },
        {
          when: "March 2023 – September 2023",
          title: "Associate Software Engineer",
          body: "Associate engineer at Kiwi Creations, before the move to CodingCops.",
          tags: [],
          place: "Lahore",
        },
        {
          when: "Aug 2022 – Jan 2023",
          title: "Teaching Assistant",
          body: "Taught while studying BS Computer Science at the National University of Computer and Emerging Sciences.",
          tags: ["BS Computer Science"],
          place: "FAST-NUCES",
        },
      ],
    },
  },
  de: {
    meta: "Ali Idrees, Softwareentwickler bei Brainchimps. M.Sc. AI Engineering an der Universität Passau.",
    nav: {
      label: "Seite",
      about: "über",
      experience: "erfahrung",
      projects: "projekte",
      skills: "skills",
      contact: "kontakt",
    },
    theme: { toLight: "Zum hellen Modus wechseln", toDark: "Zum dunklen Modus wechseln" },
    lang: { switch: "Zu Englisch wechseln" },
    hero: {
      role: "informatiker {softwareentwickler} - mensch",
      bio: "Full-Stack-Entwickler bei Brainchimps, mit Fokus auf Backend-Systeme und KI. M.Sc. AI Engineering an der Universität Passau, nach einem BS Informatik an der FAST-NUCES.",
      projects: "projekte ansehen",
      email: "mail schreiben",
      cv: "lebenslauf",
      comment: "// woran ich arbeite",
      roleValue: "Softwareentwickler",
      study: "M.Sc. AI Engineering, Passau",
      focus: ["Backend", "APIs", "KI"],
    },
    work: {
      heading: "erfahrung",
      explore: "ansehen ↗",
      items: [
        { title: "Softwareentwickler", org: "Brainchimps", when: "Sept. 2025 – Aktuell", place: "Deutschland" },
        { title: "Softwareentwickler", org: "CodingCops", when: "April 2024 – April 2025", place: "USA (Remote)" },
        { title: "Associate Softwareentwickler", org: "Kiwi Creations", when: "März 2023 – September 2023", place: "Lahore, Pakistan" },
        { title: "Tutor", org: "FAST-NUCES", when: "Aug. 2022 – Jan. 2023", place: "Lahore, Pakistan" },
      ],
    },
    study: {
      heading: "studium",
      items: [
        { degree: "M.Sc. AI Engineering", org: "Universität Passau", place: "Passau, Deutschland" },
        { degree: "BS Informatik", org: "FAST-NUCES", place: "Lahore, Pakistan" },
      ],
    },
    projects: {
      heading: "projekte",
      open: "öffnen ↗",
      all: "alle",
      empty: "Nichts unter diesem Tag.",
      filter: "Projekte filtern",
      items: [
        {
          desc: "Eine Webplattform mit mehreren Rollen, die Marken, Influencer und Kunden verbindet, inklusive Amazon-Affiliate. Kampagnen- und Dokumentenverwaltung, Mailgun-E-Mail und sichere Uploads auf AWS S3. React im Frontend, NestJS (Clean Architecture) und PostgreSQL im Backend.",
          alt: "Vorschau der UBU Platform",
        },
        {
          desc: "Eine Full-Stack-KI-Plattform auf dem MERN-Stack, angebunden an OpenAI. Strukturierte Prompts erzeugen Dokumente, PDFKit erstellt die PDFs, und OpenAI formuliert den Inhalt.",
          alt: "Vorschau von Mind Miner",
        },
        {
          desc: "Ein KI-Chatbot auf Basis von OpenAIs GPT-Modell. Embeddings und Kosinus-Ähnlichkeit halten die Antworten im richtigen Kontext.",
          alt: "Personen arbeiten gemeinsam an Laptops",
        },
      ],
    },
    skills: {
      heading: "skills",
      groups: [
        { name: "frontend", items: ["React", "TypeScript", "Tailwind"] },
        { name: "backend", items: ["NestJS", "Node.js", ".NET", "Python"] },
        { name: "daten", items: ["PostgreSQL", "MongoDB"] },
        { name: "cloud", items: ["AWS", "Docker"] },
        { name: "praxis", items: ["REST-APIs", "Clean Architecture", "Unit-Tests"] },
      ],
    },
    contact: {
      heading: "kontakt",
      intro: "Schreib eine Nachricht, oder buche eine halbe Stunde.",
      book: "30 Minuten buchen",
      name: "Name",
      email: "E-Mail",
      message: "Nachricht",
      send: "senden",
      sending: "wird gesendet",
      sent: "Gesendet. Ich antworte per E-Mail.",
      error: "Das hat nicht geklappt. Nutz die E-Mail unten.",
    },
    activity: {
      heading: "aktivität",
      unit: "Beitrag",
      unitPlural: "Beiträge",
      unavailable: "GitHub-Aktivität ist gerade nicht erreichbar.",
    },
    footer: "ali idrees · deutschland",
    experience: {
      label: "Stationen",
      next: "weiter",
      home: "zurück",
      at: "bei",
      chapters: [
        {
          when: "Sept. 2025 – Aktuell",
          title: "Softwareentwickler",
          body: "Full-Stack-Entwickler in Industrieprojekten, mit Fokus auf Backend-Systeme.",
          tags: ["Backend", "KI", "MCP"],
          place: "Deutschland",
        },
        {
          when: "April 2024 – April 2025",
          title: "Softwareentwickler",
          body: "Projektarbeit für internationale Kunden. NestJS-Backends mit Clean Architecture, REST-APIs, AWS S3 und React-Dashboards.",
          tags: ["NestJS", "React", "AWS S3", "REST"],
          place: "USA (Remote)",
        },
        {
          when: "März 2023 – September 2023",
          title: "Associate Softwareentwickler",
          body: "Associate Engineer bei Kiwi Creations, vor dem Wechsel zu CodingCops.",
          tags: [],
          place: "Lahore",
        },
        {
          when: "Aug. 2022 – Jan. 2023",
          title: "Tutor",
          body: "Tutor während des BS-Informatikstudiums an der National University of Computer and Emerging Sciences.",
          tags: ["BS Informatik"],
          place: "FAST-NUCES",
        },
      ],
    },
  },
};
